import {
  Box,
  Button,
  CircularProgress,
  Grid,
  InputLabel,
  MenuItem,
  Select,
  Switch,
  TextField,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  DialogTitle,
} from '@mui/material';
import AdminPageLoader from 'csam/admin/components/AdminPageLoader';
import AdminWrapper from 'csam/admin/components/AdminWrapper';
import LocaleButtonGroup from 'csam/admin/components/LocaleButtonGroup';
import useTranslatableFields from 'csam/admin/hooks/UseTranslateble,';
import AdminInternalError from 'csam/admin/pages/AdminInternalError';
import { useAuthenticatedMutation, useAuthenticatedQuery } from 'csam/api/api';
import LocaleContext from 'csam/components/LocaleContext';
import { fixed, getImage } from 'csam/utils/Constants';
import React, { useContext, useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

interface TemplateData {
  year_id: number;
  status: number;
  template_title: string;
  email_subject: string;
  email_body: string;
  template_link: string
  template_identifier: string
  image: string | File;
  [key: string]: string | number | File;
}

interface TranslationData {
  image: string | File;
  template_title: string;
  email_subject: string;
  email_body: string;
  template_link: string
  template_identifier: string
  [key: string]: unknown;
}

interface State {
  data: TemplateData;
  translations: {
    es: TranslationData;
    pt: TranslationData;
    zh: TranslationData;
  };
}
const AddEmailTemplate = () => {
  const initialState = {
    data: { year_id: 0, template_title: '', email_subject: '', email_body: '', image: '',status: 0 },
    translations: {
      es: { image: '', template_title: '', email_subject: '', email_body: '',template_link: '',template_identifier: '' },
      pt: { image: '', template_title: '', email_subject: '', email_body: '' ,template_link: '',template_identifier: ''},
      zh: { image: '', template_title: '', email_subject: '', email_body: '',template_link: '',template_identifier: ''},
    },
  };

  const [templateData, setTemplateData] = useState<State>(initialState);
  const { locale } = useContext(LocaleContext);
  const [loading, setLoading] = useState(false);
  const imageName = templateData.data.image;
const [generatedLink, setGeneratedLink] = useState<string>('');

  const navigate = useNavigate();
  const { id } = useParams<{ id?: string }>();

  const slug = `email_templates`;

  const { translatePending, errorTranslate, translateData, disabledFields, setLocale } = useTranslatableFields(
    slug,
    initialState,
  );

  useEffect(() => {
    if (!id) {
      setLocale('en');
    }
  }, [id, setLocale]);

  const query = useAuthenticatedQuery(
    ['email_templates', id],
    {
      url: `${fixed}admin/en/email_templates/${id}`,
    },
    {
      enabled: !!id,
    },
  );

  useEffect(() => {
    if (query.data && query.data.success) {
      setTemplateData(query.data.data as State);
    }
  }, [query.data]);

  const isUpdateForm = Boolean(id);

  const mutation = useAuthenticatedMutation(
    isUpdateForm ? ['uupdate-email-template', 'PUT'] : ['add-email-template', 'POST'],

    (data) => {
      const headers = data instanceof FormData ? {} : { 'Content-Type': 'application/json' };

      return {
        url: `${fixed}admin/${locale}/email_templates${isUpdateForm ? `/${id}` : ''}`,

        method: isUpdateForm ? 'PUT' : 'POST',

        headers,

        data,
      };
    },
  );




// const TemplateLinkModal = ({ generatedLink, onClose }: { generatedLink: string, onClose: () => void }) => {
//   return (
//     <Dialog open={Boolean(generatedLink)} onClose={onClose}>
//       <DialogTitle>Template Link Generated</DialogTitle>
//       <DialogContent>
//         <Typography variant="body1">
//           Here is the link to your generated template:
//         </Typography>
//         <Typography variant="body2" color="primary" style={{ wordBreak: 'break-all' }}>
//           <a href={generatedLink} target="_blank" rel="noopener noreferrer">
//             {generatedLink}
//           </a>
//         </Typography>
//       </DialogContent>
//       <DialogActions>
//         <Button onClick={onClose} color="primary">
//           Close
//         </Button>
//       </DialogActions>
//     </Dialog>
//   );
// };

const TemplateLinkModal = ({ generatedLink, onClose }: { generatedLink: string, onClose: () => void }) => {
  return (
    <Dialog
  open={Boolean(generatedLink)}
  onClose={onClose}
  sx={{
    '& .MuiDialog-paper': {
      backgroundColor: '#1e1e2f !important',  // 🔥 FORCE solid color
      color: '#fff',
      borderRadius: '12px',
      padding: '16px',
      boxShadow: '0 10px 30px rgba(0,0,0,0.8)',
    },
  }}
  
>
      <DialogTitle sx={{ fontWeight: 600, fontSize: 20 }}>
        Template Link Generated
      </DialogTitle>

      <DialogContent>
        <Typography variant="body1" sx={{ mb: 2, color: '#ccc' }}>
          Here is the link to your generated template:
        </Typography>

        <Box
          sx={{
            background: '#2a2a40',
            padding: 2,
            borderRadius: 2,
            wordBreak: 'break-all',
          }}
        >
          <a
            href={generatedLink}
            target="_blank"
            rel="noopener noreferrer"
            style={{
              color: '#4dabf7',
              textDecoration: 'none',
              fontWeight: 500,
            }}
          >
            {generatedLink}
          </a>
        </Box>
      </DialogContent>

      <DialogActions>
        <Button
          onClick={onClose}
          variant="contained"
          sx={{
            background: '#4dabf7',
            textTransform: 'none',
            borderRadius: 2,
            px: 3,
          }}
        >
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};
  const {
    data: yearsData,
    error: yearsError,
    isPending: yearIsPending,
  } = useAuthenticatedQuery(['fetch-years', 'GET'], {
    url: `${fixed}admin/en/calender_years`,
    method: 'GET',
    headers: { 'Content-Type': 'application/json' },
  });

  interface YearData {
    id: number;
    year_id: string;
    year: string;
  }

  if (translatePending) return <AdminPageLoader />;
  if (errorTranslate) return <Box>Error: {errorTranslate.message}</Box>;
  if (translateData && !translateData.success) return <AdminInternalError />;

  if (yearIsPending) return <AdminPageLoader />;
  if (yearsError) return <Box>Error: {yearsError.message}</Box>;
  if (yearsData && !yearsData.success) return <AdminInternalError />;

  const handleChange = (event: { target: { name: string; value: string | number; checked?: boolean } }) => {
    // eslint-disable-next-line prefer-const
    let { name, value, checked } = event.target;

    if (name === 'status') {
      value = checked ? 1 : 0;
    }

    if (translateData) {
      const translatableFields = translateData.data;

      setTemplateData((prevState) => {
        let newData = prevState.data;
        let newTranslations = prevState.translations;

        if (locale !== 'en' && translatableFields.includes(name)) {
          newTranslations = {
            ...prevState.translations,
            [locale as keyof typeof prevState.translations]: {
              ...(prevState.translations[locale as keyof typeof prevState.translations] || {}),
              [name]: value,
            },
          };
        } else {
          newData = {
            ...prevState.data,
            [name]: value,
          };
        }

        return {
          data: newData,
          translations: newTranslations,
        };
      });
    }
  };

  const handleImageChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      const date = new Date().toISOString();
      const tableName = 'email_templates';
      let fileName;

      if (locale === 'en') {
        fileName = `${date}_${tableName}_${file.name}`;
      } else {
        fileName = `${locale}_${tableName}_${file.name}`;
      }

      const newFile = new File([file], fileName, { type: file.type });

      setTemplateData((prevData) => {
        let newData = { ...prevData.data };
        let newTranslations = { ...prevData.translations };
        if (locale === 'en') {
          newData = {
            ...newData,
            [event.target.name]: newFile,
          };
        } else {
          newTranslations = {
            ...newTranslations,
            [locale]: {
              ...(newTranslations[locale as keyof State['translations']] || {}),
              [event.target.name]: newFile,
            },
          };
        }
        return {
          data: newData,
          translations: newTranslations,
        };
      });
    }
  };

  const appendToFormData = (formData: FormData, data: Record<string, unknown>, baseKey: string) => {
    Object.entries(data).forEach(([key, value]) => {
      const fullKey = `${baseKey}[${key}]`;

      if (value instanceof File) {
        formData.append(fullKey, value);
      } else if (typeof value === 'object' && value !== null) {
        formData.append(fullKey, JSON.stringify(value));
      } else {
        formData.append(fullKey, String(value));
      }
    });
  };

  const handleSubmit = async (e: React.FormEvent<HTMLFormElement>) => {
    e.preventDefault();

    setLoading(true);

    const formData = new FormData();


    

    const data = { ...templateData };

    if (data) {
      delete data.translations;
    }
let uniqueIdentifier = data.data.template_identifier;
    console.log("uniqueidentifier",uniqueIdentifier);
    // data.data.template_link = `http://localhost:5000/${locale}/abi-login-1/${uniqueIdentifier}`;
    // data.data.template_identifier = uniqueIdentifier;

    if (!data.data.template_identifier) {
  // Only generate if it's a new template (no identifier yet)
  uniqueIdentifier = `template_${Date.now()}`;
  data.data.template_identifier = uniqueIdentifier;
  data.data.template_link = `https://gcp-cybersecurityandcompliance-awareness.ab-inbev.com/${locale}/${uniqueIdentifier}/abi-login-1`;
}

 setGeneratedLink(`https://gcp-cybersecurityandcompliance-awareness.ab-inbev.com/${locale}/${uniqueIdentifier}/abi-login-1`)

    
    formData.append('email_body', data.data.email_body);
    appendToFormData(formData, data, 'data');

    if (templateData.data.image instanceof File) {
      formData.append('image', templateData.data.image);
    }


    formData.append('template_link', data.data.template_link);
    formData.append('template_identifier', data.data.template_identifier);

    if (templateData?.translations) {
      Object.entries(templateData.translations).forEach(([localeKey, translation]) => {
        // console.log(translation);
        const updatedTranslation = {
    ...translation,
    template_link: data.data.template_link,              // ✅ ADD
    template_identifier: data.data.template_identifier,  // ✅ ADD
  };
        
        appendToFormData(formData, updatedTranslation, `translations[${localeKey}]`);
      });
    }

    try {
      await mutation.mutateAsync(formData, {
        onSuccess: (responseData) => {
          // console.log(responseData);
          
    //        toast.success(
    //   <div>
    //     <p>Template Link Generated Successfully!</p>
    //     <a href={data.data.template_link} target="_blank" rel="noopener noreferrer">
    //       {data.data.template_link}
    //     </a>
    //   </div>
    // );
          toast.success(`Record ${responseData ? 'Updated' : 'Added'} Successfully`);
           // Adjust based on actual response structure

        // Generate the link using the newTemplateId and locale
        

          setTimeout(() => {
            navigate('/admin/email-templates');
          }, 6000000);
        },

        onError: () => {
          console.log('An error occurred while saving the data.');
        },
      });
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleSetLocale = (newLocale: string) => {
    if (locale === 'en' && newLocale !== 'en') {
      for (const key in templateData.data) {
        if (
          templateData.data[key] === undefined ||
          templateData.data[key] === '' ||
          (templateData.data[key] === 0 && key !== 'status')
        ) {
          toast.error(`Please fill in the ${key} field first`);
          return;
        }
      }
    }

    setLocale(newLocale);
  };

  return (
    <AdminWrapper>
      <Box className="pageHeader">
        <Box sx={{ display: 'flex', gap: 2 }}>
          <Typography variant="h6"> {isUpdateForm ? 'Edit Email Template' : 'Add Email Template'} </Typography>
        </Box>
        <LocaleButtonGroup currentLocale={locale} setLocale={handleSetLocale} />
      </Box>
      <Box component="form" onSubmit={handleSubmit} encType="multipart/form-data">
        <Grid container spacing={2}>
          <Grid item sm={6}>
            <InputLabel id="year-label">Year</InputLabel>
            <Select
              fullWidth
              labelId="year-label"
              name="year_id"
              size="small"
              value={templateData.data.year_id === 0 ? '' : templateData.data.year_id.toString()}
              onChange={handleChange}
              disabled={disabledFields.includes('year_id')}
              required={locale === 'en'}
            >
              {(yearsData.data as YearData[]).map((year: YearData) => (
                <MenuItem key={year.id} value={year.id.toString()}>
                  {year.year}
                </MenuItem>
              ))}
            </Select>
          </Grid>

          <Grid item sm={6}>
            <Box className="form-group">
              <InputLabel id="monthTitle-label">
              Template Title <Typography component="sup">{locale.toUpperCase()}</Typography>
              </InputLabel>
              <TextField
                placeholder="Add Template Title"
                size="small"
                name="template_title"
                value={
                  locale === 'en'
                    ? templateData.data.template_title
                    : templateData.translations[locale as keyof State['translations']]?.template_title || ''
                }
                onChange={handleChange}
                disabled={disabledFields.includes('template_title')}
                fullWidth
              />
            </Box>
          </Grid>

          <Grid item sm={12}>
            <Box className="form-group">
              <InputLabel id="monthTitle-label">
                Email Subject <Typography component="sup">{locale.toUpperCase()}</Typography>
              </InputLabel>
              <TextField
                placeholder="Add Email Subject"
                size="small"
                name="email_subject"
                value={
                  locale === 'en'
                    ? templateData.data.email_subject
                    : templateData.translations[locale as keyof State['translations']]?.email_subject || ''
                }
                onChange={handleChange}
                disabled={disabledFields.includes('email_subject')}
                fullWidth
              />
            </Box>
          </Grid>

          <Grid item sm={12}>
            <Box className="form-group">
              <InputLabel id="monthTitle-label">
                Email Body <Typography component="sup">{locale.toUpperCase()}</Typography>
              </InputLabel>
              <TextField
                placeholder="Add Email Body"
                size="small"
                name="email_body"
                multiline
                rows={4}
                value={
                  locale === 'en'
                    ? templateData.data.email_body
                    : templateData.translations[locale as keyof State['translations']]?.email_body || ''
                }
                onChange={handleChange}
                disabled={disabledFields.includes('email_body')}
                fullWidth
              />
            </Box>
          </Grid>

          <Grid item sm={12}>
            <Box className="form-group">
              <InputLabel>
                image <Typography component="sup">{locale.toUpperCase()}</Typography>
              </InputLabel>
              <TextField
                type="file"
                name="image"
                onChange={handleImageChange}
                disabled={disabledFields.includes('image')}
                fullWidth
              />
              {imageName && (
                <img
                  className="formImage"
                  src={`${getImage}email_templates/${locale === 'en' ? imageName : templateData.translations[locale as keyof typeof templateData.translations]?.image}`}
                  alt=""
                />
              )}
            </Box>
          </Grid>

{/* 
                 <Grid item sm={12}>
            <Button 
              variant="contained" 
              color="primary" 
              onClick={handleGenerateLink} 
              disabled={loading}
            >
              Generate Template Link
            </Button>
          </Grid>

{generatedLink && (
            <Box mt={4} sx={{ background: '#f4f4f4', padding: 2, borderRadius: 2 }}>
              <Typography variant="h6">Generated Template Link</Typography>
              <Box mt={2}>
                <a href={generatedLink} target="_blank" rel="noopener noreferrer">
                  {generatedLink}
                </a>
              </Box>
            </Box>
          )} */}


        form onSubmit
          <Grid item sm={6}>
            <InputLabel id="status-label">Status</InputLabel>
            <Grid container alignItems="center">
              <Typography>Inactive</Typography>
              <Switch
                id="status-label"
                name="status"
                onChange={handleChange}
                checked={Boolean(templateData.data.status)}
                disabled={locale !== 'en'}
              />
              <Typography>Active</Typography>
            </Grid>
          </Grid>

          <Grid item sm={12}>
            <Button type="submit" variant="contained" color="primary" disabled={loading}>
              {loading && <CircularProgress size={16} sx={{ mr: 1 }} />} Submit
            </Button>
          </Grid>
        </Grid>
      </Box>
      <TemplateLinkModal generatedLink={generatedLink} onClose={() => setGeneratedLink('')} />

    </AdminWrapper>
  );
};

export default AddEmailTemplate;

